/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_IdInputs */

const en_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const es_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const de_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const zh_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const ar_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const fr_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const vi_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const sw_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const th_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const bs_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const ja_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const ko_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const pt_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const it_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const sv_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const nl_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const da_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const nb_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const fi_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const pl_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const ru_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const tr_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const hi_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const id_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const ms_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const cs_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const el_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const he_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const af_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const hu_nav_language_id = /** @type {(inputs: Nav_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

/**
* | output |
* | --- |
* | "Bahasa Indonesia" |
*
* @param {Nav_Language_IdInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_id = /** @type {((inputs?: Nav_Language_IdInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_IdInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_id(inputs)
	if (locale === "de") return de_nav_language_id(inputs)
	if (locale === "zh") return zh_nav_language_id(inputs)
	if (locale === "ar") return ar_nav_language_id(inputs)
	if (locale === "fr") return fr_nav_language_id(inputs)
	if (locale === "vi") return vi_nav_language_id(inputs)
	if (locale === "sw") return sw_nav_language_id(inputs)
	if (locale === "th") return th_nav_language_id(inputs)
	if (locale === "bs") return bs_nav_language_id(inputs)
	if (locale === "ja") return ja_nav_language_id(inputs)
	if (locale === "ko") return ko_nav_language_id(inputs)
	if (locale === "pt") return pt_nav_language_id(inputs)
	if (locale === "it") return it_nav_language_id(inputs)
	if (locale === "sv") return sv_nav_language_id(inputs)
	if (locale === "nl") return nl_nav_language_id(inputs)
	if (locale === "da") return da_nav_language_id(inputs)
	if (locale === "nb") return nb_nav_language_id(inputs)
	if (locale === "fi") return fi_nav_language_id(inputs)
	if (locale === "pl") return pl_nav_language_id(inputs)
	if (locale === "ru") return ru_nav_language_id(inputs)
	if (locale === "tr") return tr_nav_language_id(inputs)
	if (locale === "hi") return hi_nav_language_id(inputs)
	if (locale === "id") return id_nav_language_id(inputs)
	if (locale === "ms") return ms_nav_language_id(inputs)
	if (locale === "cs") return cs_nav_language_id(inputs)
	if (locale === "el") return el_nav_language_id(inputs)
	if (locale === "he") return he_nav_language_id(inputs)
	if (locale === "af") return af_nav_language_id(inputs)
	if (locale === "hu") return hu_nav_language_id(inputs)
	return en_nav_language_id(inputs)
});